import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductType } from '../../../../../products/types';
import Dumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import Flex from '@wix/da-ds/pkg/Flex';
import { PapiDataPackageSellerTopProducts } from '@wix/da-papi-types';
import DeviationLink from '@wix/da-shared-react/pkg/Duperbrowse/DeviationLink';
import FolderLink from '@wix/da-shared-react/pkg/FolderCard/_partials/FolderLink';

import s from './TopSellingProductsTableRowHeadingMobile.scss';

interface Props {
  item: NonNullable<
    PapiDataPackageSellerTopProducts['timePeriods']['ALL']
  >[number];
}

const TopSellingProductsTableRowHeadingMobile: FC<Props> = ({ item }) => {
  const { t } = useTranslation();

  const { productType, deviation, premiumGallery } = item;

  const { title, thumb } =
    productType === ProductType.PremiumGallery
      ? { title: premiumGallery?.name, thumb: premiumGallery?.thumb }
      : { title: deviation?.title, thumb: deviation };

  const dumbo = thumb && (
    <Dumbo className={s['thumb']} width={70} height={70} deviation={thumb} />
  );

  return (
    <div className={s['root']}>
      {productType === ProductType.PremiumGallery
        ? premiumGallery && (
            <FolderLink folder={premiumGallery}>{dumbo}</FolderLink>
          )
        : deviation && (
            <DeviationLink deviation={deviation}>{dumbo}</DeviationLink>
          )}
      <Flex direction="column" gap={4}>
        <div className={s['title']}>{title}</div>
        <div className={s['product-type']}>
          {t(`common.productName.type.${productType}`)}
        </div>
      </Flex>
    </div>
  );
};
TopSellingProductsTableRowHeadingMobile.displayName =
  'TopSellingProductsTableRowHeadingMobile';

export default TopSellingProductsTableRowHeadingMobile;
